import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MenuItems = (props) => {

    const { parentMenu } = props;

    const location = useLocation();
    const postURL = location.pathname.split('/');
    const pathLength = Number(postURL.length)

    const [home, setHome] = useState(false)
    const [page, setPage] = useState(false)
    const [event, setEvent] = useState(false)
    const [course, setCourse] = useState(false)
    const [blog, setBlog] = useState(false)

    const openMobileMenu = menu => {

        if (menu === 'home') {
            setHome(!home)
            setPage(false)
            setEvent(false)
            setCourse(false)
            setBlog(false)
        }
        else if (menu === 'page') {
            setHome(false)
            setPage(!page)
            setEvent(false)
            setCourse(false)
            setBlog(false)
        }
        else if (menu === 'event') {
            setHome(false)
            setPage(false)
            setEvent(!event)
            setCourse(false)
            setBlog(false)
        }
        else if (menu === 'course') {
            setHome(false)
            setPage(false)
            setEvent(false)
            setCourse(!course)
            setBlog(false)
        }
        else if (menu === 'blog') {
            setHome(false)
            setPage(false)
            setEvent(false)
            setCourse(false)
            setBlog(!blog)
        }
    };

    return (
        <>
            {/* <li className={parentMenu === 'home' ? 'has-sub menu-active' : 'has-sub'}>
                <Link to="/" className={home ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('home'); }}>
                    Home
                    <span className="arrow "></span>
                </Link>
                <ul className={home ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === "/" ? "menu-active" : ""}>
                        <Link to="/">Home One</Link>
                    </li>
                    <li className={location.pathname === "/home-2" ? "menu-active" : ""}>
                        <Link to="/home-2">Home Two</Link>
                    </li>
                    <li className={location.pathname === "/home-3" ? "menu-active" : ""}>
                        <Link to="/home-3">Home Three</Link>
                    </li>
                </ul>
            </li>

            <li className={parentMenu === 'page' || parentMenu === 'event' ? 'has-sub menu-active' : 'has-sub'}>
                <Link to="#" className={page ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('page'); }}>
                    Pages
                    <span className="arrow "></span>
                </Link>
                <ul className={page ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === '/about' ? 'menu-active' : ''}>
                        <Link to="/about">About</Link>
                    </li>
                    <li className={location.pathname === "/instructor" ? "menu-active" : ""}>
                        <Link to="/instructor">Instructor</Link>
                    </li>
                    <li className={postURL[1] === "instructor" && pathLength > 2 ? "menu-active" : ""}>
                        <Link to="/instructor/1">Profile</Link>
                    </li>
                    <li className={location.pathname === "/login" ? "menu-active" : ""}>
                        <Link to="/login">Login</Link>
                    </li>
                    <li className={location.pathname === "/signup" ? "menu-active" : ""}>
                        <Link to="/signup">Signup</Link>
                    </li>
                    <li className={parentMenu === 'event' ? 'has-sub menu-active' : 'has-sub'}>
                        <Link to="#" className={event ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('event'); }}>Events</Link>
                        <ul className={event ? "sub-menu sub-menu-open" : "sub-menu"}>
                            <li className={location.pathname === "/event" ? "menu-active" : ""}>
                                <Link to="/event">Events</Link>
                            </li>
                            <li className={location.pathname === "/event-sidebar" ? "menu-active" : ""}>
                                <Link to="/event-sidebar">Events Sidebar</Link>
                            </li>
                            <li className={postURL[1] === "event" && pathLength > 2 ? "menu-active" : ""}>
                                <Link to="/event/1">Event Single</Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>

            <li className={parentMenu === 'course' ? 'has-sub menu-active' : 'has-sub'}>
                <span className="arrow "></span>
                <Link to="#" className={course ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('course'); }}>
                    Courses
                    <span className="arrow "></span>
                </Link>
                <ul className={course ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === "/course" ? "menu-active" : ""}>
                        <Link to="/course">Course</Link>
                    </li>
                    <li className={location.pathname === "/course-sidebar" ? "menu-active" : ""}>
                        <Link to="/course-sidebar">Right Sidebar</Link>
                    </li>
                    <li className={location.pathname === "/course-list" ? "menu-active" : ""}>
                        <Link to="/course-list">Courses List</Link>
                    </li>
                    <li className={postURL[1] === "course" && pathLength > 2 ? "menu-active" : ""}>
                        <Link to="/course/1">Course Single</Link>
                    </li>
                </ul>
            </li>

            <li className={parentMenu === 'blog' ? 'has-sub menu-active' : 'has-sub'}>
                <Link to="#" className={blog ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('blog'); }}>
                    Blog
                    <span className="arrow "></span>
                </Link>
                <ul className={blog ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === "/blog" ? "menu-active" : ""}>
                        <Link to="/blog">Blog</Link>
                    </li>
                    <li className={postURL[1] === "blog" && pathLength > 2 ? "menu-active" : ""}>
                        <Link to="/blog/1">Blog Single</Link>
                    </li>
                </ul>
            </li> */}
              <li className={location.pathname === '/' ? 'menu-active' : ''}>
                <Link to="/">Home</Link>
            </li>
            <li className={location.pathname === '/about' ? 'menu-active' : ''}>
                <Link to="/about">About</Link>
            </li>
            <li className={location.pathname === '/course/1' ? 'menu-active' : ''}>
                <Link to="/course">Courses</Link>
            </li>

            <li className={location.pathname === '/goverment-partners' || location.pathname === '/industry-partners' ? 'has-sub menu-active' : 'has-sub'}>
                <Link to="#" className={page ? "hash menu-active" : "hash"} onClick={() => { openMobileMenu('page'); }}>
                    Our Partners
                    <span className="arrow ps-3"></span>
                </Link>
                <ul className={page ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === '/goverment-partners' ? 'menu-active' : ''}>
                        <Link className='text-nowrap' to="/goverment-partners">Government Partners</Link>
                    </li>
                    <li className={location.pathname === "/industry-partners" ? "menu-active" : ""}>
                        <Link to="/industry-partners">Industry Partners</Link>
                    </li>
                </ul>
            </li>
            {/* <li className={location.pathname === '/partners' ? 'menu-active' : ''}>
                <Link to="/partnersa">Our Partners</Link>
            </li> */}
            <li className={location.pathname === '/award-&-recognition' ? 'menu-active' : ''}>
                <Link to="/award-&-recognition">Awards & Recognition</Link>
            </li>
            <li className={location.pathname === '/career' ? 'menu-active' : ''}>
                <Link to="/career">Careers</Link>
            </li>
            {/* <li className={location.pathname === '/contact' ? 'menu-active' : ''}>
                <Link to="/contact">Contact</Link>
            </li> */}
            <li>
            <Link to="/contact" style={{ paddingTop: "25px", paddingRight: "15px" }}>
                <button style={{ background: "#FE7743", color: "white", border: "none", padding: "10px 25px" }}>
                    <svg style={{marginRight:"15px"}} xmlns="http://www.w3.org/2000/svg" width="15.932" height="15.93" viewBox="0 0 16.932 16.93">
                        <path id="Icon_ion-ios-call" data-name="Icon ion-ios-call" d="M20.932,17.759a14.221,14.221,0,0,0-2.971-1.988c-.89-.428-1.217-.419-1.847.035-.525.379-.864.732-1.468.6A8.756,8.756,0,0,1,11.7,14.224a8.693,8.693,0,0,1-2.182-2.949c-.128-.608.225-.943.6-1.468.454-.63.467-.956.035-1.847A13.94,13.94,0,0,0,8.163,4.99c-.648-.648-.793-.507-1.15-.379a6.546,6.546,0,0,0-1.053.56A3.178,3.178,0,0,0,4.695,6.506c-.251.542-.542,1.551.939,4.187a23.364,23.364,0,0,0,4.108,5.479l0,0,0,0a23.456,23.456,0,0,0,5.479,4.108c2.636,1.481,3.645,1.19,4.187.939a3.124,3.124,0,0,0,1.336-1.265,6.546,6.546,0,0,0,.56-1.053C21.439,18.552,21.585,18.407,20.932,17.759Z" transform="translate(-4.49 -4.502)" fill="#fff" />
                    </svg>Contact
                </button>
            </Link>
            </li>

        </>
    );
}

export default MenuItems;